import { c as h, i, l as a, o as c, s as u, u as r } from "./core-CongXJuo.js";
import { a as d, r as o } from "./effect-Cc51IH91.js";
var l = class {
  constructor(s) {
    this.compute = s, this.hasCachedValue = !1, this.dirty = !0, this.disposed = !1, this.subscribers = /* @__PURE__ */ new Set(), this.markDirty = () => {
      if (this.disposed) return;
      this.dirty = !0;
      const e = Array.from(this.subscribers);
      for (const t of e) h(t);
    };
  }
  get value() {
    if (this.disposed)
      return this.hasCachedValue || (this.cachedValue = r(() => this.compute()), this.hasCachedValue = !0), this.cachedValue;
    const s = c();
    return s && (this.subscribers.add(s), u(s, this)), this.dirty && (this.dirty = !1, i(this.markDirty), this.cachedValue = a(this.markDirty, this.compute), this.hasCachedValue = !0), this.cachedValue;
  }
  peek() {
    return this.disposed ? (this.hasCachedValue || (this.cachedValue = r(() => this.compute()), this.hasCachedValue = !0), this.cachedValue) : (this.dirty && (this.dirty = !1, i(this.markDirty), this.cachedValue = a(this.markDirty, this.compute), this.hasCachedValue = !0), this.cachedValue);
  }
  unsubscribe(s) {
    this.subscribers.delete(s);
  }
  dispose() {
    this.disposed = !0, this.dirty && (this.hasCachedValue = !1), this.dirty = !1, i(this.markDirty), this.subscribers.clear();
  }
}, f = (s) => {
  const e = new l(s), t = o();
  return d(t) && t._addDisposer(() => e.dispose()), e;
}, b = (s) => r(s);
export {
  l as n,
  f as r,
  b as t
};

//# sourceMappingURL=untrack-bjWDNdyE.js.map